import { DialogActions } from '@mui/material';
import CustomButton from '../inputs/CustomButton';

const Actions = ({
  handleClose,
  handleSave,
  saveButtonProps = {},
  cancelButtonProps = {},
  saveLabel = 'Guardar',
  savingLabel = 'Guardando...',
  cancelLabel = 'Cancelar',
}) => {
  const {
    isLoading: saveIsLoading = false,
    children: saveChildren,
    ...restSaveProps
  } = saveButtonProps;
  const {
    disabled: cancelDisabled = false,
    children: cancelChildren,
    ...restCancelProps
  } = cancelButtonProps;

  return (
    <DialogActions
      sx={{
        width: '100%',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 1,
        p: 2,
        '& > :not(style) ~ :not(style)': { ml: { xs: 0, sm: 1 } },
      }}
    >
      <CustomButton
        onClick={handleSave}
        variant="base"
        isLoading={saveIsLoading}
        sx={{ width: { xs: '100%', sm: 'auto' } }}
        {...restSaveProps}
      >
        {saveIsLoading ? savingLabel : saveChildren || saveLabel}
      </CustomButton>
      <CustomButton
        onClick={handleClose}
        variant="danger"
        disabled={cancelDisabled || saveIsLoading}
        sx={{ width: { xs: '100%', sm: 'auto' } }}
        {...restCancelProps}
      >
        {cancelChildren || cancelLabel}
      </CustomButton>
    </DialogActions>
  );
};

export default Actions;
